<ion-header class="ion-no-border" color="primary">
	<ion-toolbar color="primary">
		<ion-title>
			<div class="ion-text-wrap">Proceed to Kiosk Mode?</div>
		</ion-title>
		<ion-buttons slot="end"></ion-buttons>
	</ion-toolbar>
</ion-header>

<ion-content class="content-wrapper">
    <div class="header">
        <p>Are you sure you want to set this device to Kiosk Mode? This will disable the keyboard. You must restart the device to exit.</p>
    </div>
    <div class="printer-wrapper">
        <ion-list-header>
            <ion-label>Select Printer</ion-label>
        </ion-list-header>
        <ion-item class="select-item"
                lines="none"
                (click)="handleSelectPrinterPress()">
            <ion-input aria-label="select printer"
                        fill="outline"
                        placeholder="Select a printer"
                        readonly="true"
                        [value]="selectedPrinter?.name"
                        data-testid="select_printer_ion_input"
                        [disabled]="printerSelectOpen">
                        <ion-button fill="clear" slot="end" aria-label="Select Printer">
                            <fa-icon [icon]="faChevronRight" [fixedWidth]="true" size="1x"></fa-icon>
                        </ion-button>
            </ion-input>
            
            
        </ion-item>
    </div>
    <div class="buttons">
        <button class="nav-btn" (click)="back()">
            Go back
        </button>
        <button class="nav-btn" (click)="proceed()">
            Launch Kiosk Mode
        </button>
    </div>
</ion-content>
